import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import {
	AnalyticsEventActions,
	AnalyticsEventSource,
	useAnalytics,
	useTeamCentralPresent,
} from '@atlassian/ptc-common';

import { useAppConfig } from '../../../AppConfigContext';

import AtlasLogoIcon from './AtlasLogoIcon';
import { messages } from './messages';
import {
	PoweredByAtlasContainer,
	type PoweredByAtlasStyleProps,
	PoweredByAtlasText,
} from './styles';

type PoweredByAtlasProps = Partial<PoweredByAtlasStyleProps> & {
	utmMedium: string;
	isTeamProfile?: boolean;
};

export const PoweredByAtlas = ({
	size = 'small',
	utmMedium,
	isTeamProfile,
}: PoweredByAtlasProps) => {
	const analytics = useAnalytics();
	const [isTeamCentralPresent] = useTeamCentralPresent();
	const { productName } = useAppConfig();
	const atlasLink = `https://www.atlassian.com/software/atlas?utm_source=${productName}&utm_medium=${utmMedium}&utm_campaign=powered-by-atlas`;

	return (
		<PoweredByAtlasContainer
			size={size}
			href={atlasLink}
			onClick={() => {
				analytics.pushTrackEvent({
					source: isTeamProfile
						? AnalyticsEventSource.TEAM_PROFILE_SCREEN
						: AnalyticsEventSource.USER_PROFILE_SCREEN,
					action: AnalyticsEventActions.CLICKED,
					actionSubject: 'PoweredByAtlas',
					attributes: {
						atlasPresent: isTeamCentralPresent,
						source: productName,
					},
					tags: ['watermelon'],
				});
			}}
		>
			<AtlasLogoIcon label="Atlas" size={size} />
			<PoweredByAtlasText size={size}>
				<FormattedMessage {...messages.PoweredByAtlas} />
			</PoweredByAtlasText>
		</PoweredByAtlasContainer>
	);
};
